import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldHalved,
  faArrowRight,
  faCheck,
  faHeadset,
  faBolt,
  faLock,
  faShield,
} from "@fortawesome/free-solid-svg-icons";
import "./Hero.css";

const Hero = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();

  const brand = webinfo?.name || "SecureHub";
  const phoneLabel = webinfo?.phone || "Call a security expert";
  const phoneHref = useMemo(() => {
    const raw = webinfo?.phonecall || webinfo?.phone;
    return raw ? `tel:${raw}` : "/contact";
  }, [webinfo?.phonecall, webinfo?.phone]);

  useEffect(() => {
    document.title = `Home | ${brand}`;
  }, [brand]);

  return (
    <section className="hero-v2" aria-label={`${brand} protection services`}>
      <div className="hero-v2-bg">
        <div className="hero-v2-gradient" aria-hidden="true" />
        <div className="hero-v2-grid" aria-hidden="true" />
      </div>

      <div className="hero-v2-inner">
        <div className="hero-v2-content">
          <div className="hero-v2-badge">
            <FontAwesomeIcon icon={faShieldHalved} />
            <span>Trusted security, real support</span>
          </div>

          <h1 className="hero-v2-title">
            Security that
            <span className="hero-v2-title-accent"> just works.</span>
          </h1>

          <p className="hero-v2-sub">
            {brand} gets you the right protection for your devices — with a real
            person to help you set it up. No jargon, no runaround.
          </p>

          <div className="hero-v2-trust">
            <span>
              <FontAwesomeIcon icon={faCheck} /> Verified licenses
            </span>
            <span>
              <FontAwesomeIcon icon={faCheck} /> Setup on call
            </span>
            <span>
              <FontAwesomeIcon icon={faCheck} /> Human support
            </span>
          </div>

          <div className="hero-v2-actions">
            <button
              className="hero-v2-btn hero-v2-btn-primary"
              type="button"
              onClick={() => navigate("/norton")}
            >
              View plans
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <a
              className="hero-v2-btn hero-v2-btn-ghost"
              href={phoneHref}
            >
              Talk to an expert
            </a>
          </div>
        </div>

        <div className="hero-v2-side">
          <div className="hero-v2-card">
            <div className="hero-v2-card-header">
              <span className="hero-v2-card-tag">Recommended</span>
              <h2 className="hero-v2-card-title">Everyday Protection</h2>
              <p className="hero-v2-card-desc">
                Best for families — antivirus, VPN & support across devices.
              </p>
            </div>

            <div className="hero-v2-price">
              <span className="hero-v2-currency">₹</span>
              <span className="hero-v2-amount">399</span>
              <span className="hero-v2-period">/year</span>
            </div>
            <p className="hero-v2-devices">Up to 3 devices</p>

            <ul className="hero-v2-features">
              <li><FontAwesomeIcon icon={faShield} /> Antivirus + web protection</li>
              <li><FontAwesomeIcon icon={faBolt} /> VPN included</li>
              <li><FontAwesomeIcon icon={faLock} /> Windows, Mac, Android</li>
            </ul>

            <button
              className="hero-v2-card-cta"
              type="button"
              onClick={() => navigate("/norton")}
            >
              Compare plans
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>

          <a className="hero-v2-support" href={phoneHref}>
            <FontAwesomeIcon icon={faHeadset} />
            <span>{phoneLabel}</span>
            <FontAwesomeIcon icon={faArrowRight} className="hero-v2-support-arrow" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
